import './Hamburger.css';
import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useNavigate, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBars,
  faCircleUser,
  faHouse,
  faPlus,
  faClipboardList,
  faArrowRightArrowLeft,
} from '@fortawesome/free-solid-svg-icons';

export default function Hamburger({ user }) {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  const close = () => setIsOpen(false);

  const goTo = (path) => {
    close();
    navigate(path);
  };

  const profileName = user?.isLoggedIn ? user.name || 'Unknown' : 'Not logged in';

  const profileType = user?.isLoggedIn
    ? `Account type: ${
        user.accountType === 'CONTACT_ONLY' ? 'Temporary' :
        user.accountType === 'FULL' ? 'Full' :
        'Unknown'
      }`
    : '';

  const navItems = [
    { label: 'Home',                     icon: faHouse,               path: '/' },
    { label: 'View in-progress reports', icon: faClipboardList,       path: '/progress' },
    { label: 'Switch account',           icon: faArrowRightArrowLeft, path: '/login' },
  ];

  return (
    <>
      <div className="hamburger" onClick={() => setIsOpen(true)}>
        <FontAwesomeIcon icon={faBars} className="hamburger-icon" />
      </div>

      {isOpen && createPortal(
        <>
          <div className="h-overlay" onClick={close} />
          <div className="h-panel">

            <button className="h-close" onClick={close}>✕</button>

            <div className="h-profile">
              <FontAwesomeIcon icon={faCircleUser} className="h-avatar" />
              <div className="h-profile-text">
                <span className="h-profile-name">{profileName}</span>
                {profileType && <span className="h-profile-type">{profileType}</span>}
              </div>
            </div>

            <nav className="h-nav">
              {navItems.map((item) => (
                <button
                  key={item.path}
                  className={`h-nav-btn${location.pathname === item.path ? ' active' : ''}`}
                  onClick={() => goTo(item.path)}
                >
                  <FontAwesomeIcon icon={item.icon} className="h-nav-icon" />
                  {item.label}
                </button>
              ))}
            </nav>

            <div className="h-footer">
              <span>FishTagged</span>
            </div>

          </div>
        </>,
        document.body
      )}
    </>
  );
}